import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  imagePreviewView: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    ...shorthands.margin('12px'),
    ...shorthands.gap('32px'),
    ...shorthands.flex(1),

    '& .image-preview-image-wrapper': {
      width: '598px',
      '& img': {
        width: '100%',
        height: 'auto',
      },
    },

    '& .image-preview-button-wrapper': {
      boxShadow: '0 0 2px rgba(0,0,0,0.12), 0 2px 4px rgba(0,0,0,0.14)',
      ...shorthands.borderRadius('6px'),

      '& .button-item': {
        ...shorthands.border('none'),
        ...shorthands.padding('12px'),

        '&.first-button-item': {
          borderTopLeftRadius: '6px',
          borderBottomLeftRadius: '6px',
        },

        '&.last-button-item': {
          borderTopRightRadius: '6px',
          borderBottomRightRadius: '6px',
        },
      },
    },

    '& .image-preview-notification-wrapper': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#FFFFFF',
      boxShadow: '0 0 2px rgba(0,0,0,0.12), 0 2px 4px rgba(0,0,0,0.14)',
      ...shorthands.gap('4px'),
      ...shorthands.borderRadius('6px'),
      ...shorthands.padding('12px'),
    },
  },
});
